import React, { useState } from 'react';

import {
  Box,
  Grid,
  Link,
  Theme,
  Typography,
  makeStyles,
} from '@material-ui/core';

import { ReactComponent as OkIcon } from '../../../../assets/img/icon/Ok.svg';
import FloatingButton from '../../../../components/FloatingButton';
import SuraCard from '../../../../components/SuraCard';
import { appConfig } from '../../../../config/app';
import {
  IncidentsDocuments,
  IncidentsDocumentsTypes,
} from '../../../../constants/incidents.constant';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';

const useStyle = makeStyles((theme: Theme) => ({
  selectionCard: {
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    cursor: 'pointer',

    '& img': {
      height: '60px',
    },
  },
  borderedCard: {
    border: '1px solid #FA6400',
  },
  check: {
    position: 'absolute',
    top: '5%',
    right: '5%',
  },
  checked: {
    '& path': {
      stroke: '#FA6400',
    },
  },
}));

const Part = (props: any) => {
  const { title, onChange, checked } = props;
  const classes = useStyle();
  const [selected, setSelected] = useState(checked);

  const selectCard = () => {
    onChange(!selected);
    setSelected(!selected);
  };

  const cardStyles =
    classes.selectionCard + (selected ? ' ' + classes.borderedCard : '');
  const checkStyles = classes.check + (selected ? ' ' + classes.checked : '');

  return (
    <Box m={1} onClick={selectCard}>
      <SuraCard className={cardStyles}>
        <Box p={3} pl={0}>
          <Typography align="left">{title}</Typography>
        </Box>
        <OkIcon className={checkStyles} />
      </SuraCard>
    </Box>
  );
};

const InjuredPersonsDocumentation = () => {
  const { nextStep, updateSinisterBody, sinister_body } =
    useSinisterDataContext();

  const [state, setState] = useState<any>({
    license: !!sinister_body?.crash?.involved?.documents?.filter(
      (doc: any) => doc.type === IncidentsDocumentsTypes.LICENSE
    ).length,
    vehicle_documentation: !!sinister_body?.crash?.involved?.documents?.filter(
      (doc: any) => doc.type === IncidentsDocumentsTypes.VEHICLE_DOCUMENTATION
    ).length,
    police_complaint: !!sinister_body?.crash?.involved?.documents?.filter(
      (doc: any) => doc.type === IncidentsDocumentsTypes.POLICE_COMPLAINT
    ).length,
  });

  const handleCheckboxChange = (name: string) => (value: boolean) => {
    setState({ ...state, [name]: value });
  };

  const callNextStep = () => {
    let documents = [...IncidentsDocuments];

    for (const key in state) {
      if (Object.prototype.hasOwnProperty.call(state, key)) {
        if (!state[key]) {
          documents = documents.filter((doc: any) => doc.type !== key);
        }
      }
    }

    updateSinisterBody({
      crash: {
        ...sinister_body.crash,
        involved: { ...sinister_body.crash.involved, documents },
      },
    });
    nextStep();
  };

  const { license, vehicle_documentation, police_complaint } = state;

  return (
    <Grid container>
      <Grid container item lg={12}>
        <Box my={3}>
          <Typography variant="h6">
            ¿Contás con otro tipo de documentación?
          </Typography>
        </Box>
      </Grid>
      <Grid container>
        <Grid item xs={6} md={6}>
          <Part
            title="Registro de conducir"
            checked={license}
            onChange={handleCheckboxChange('license')}
          />
        </Grid>
        <Grid item xs={6} md={6}>
          <Part
            title="Cédula azul o verde"
            checked={vehicle_documentation}
            onChange={handleCheckboxChange('vehicle_documentation')}
          />
        </Grid>
        <Grid item xs={6} md={6}>
          <Part
            title="Denuncia policial"
            checked={police_complaint}
            onChange={handleCheckboxChange('police_complaint')}
          />
        </Grid>
      </Grid>
      <Grid container item lg={12} />
      <Box mr={2} my={2}>
        <Typography>
          Si aún no dispones de la Documentación, luego puedes enviarla por
          correo electrónico a{' '}
          <Link
            href={'mailto:atencion.siniestros@galiciaseguros.com.ar'}
            rel="noopener"
            target="_blank"
            color="secondary"
          >
            atencion.siniestros@galiciaseguros.com.ar
          </Link>{' '}
          o vía{' '}
          <Link
            href={appConfig?.WHATSAPP_LINK}
            rel="noopener"
            target="_blank"
            color="secondary"
          >
            Whatsapp
          </Link>
        </Typography>
      </Box>
      <Grid container justify="center">
        <Grid item xs={12} sm={6}>
          <FloatingButton onClick={callNextStep}> Continuar </FloatingButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default InjuredPersonsDocumentation;
